
import $ from 'jquery';
import { GridAlgorithm, MarkerClusterer } from '@googlemaps/markerclusterer';
import { utils } from './Utils';

const GOOGLE_MAP_API_KEY = process.env.REACT_APP_GOOGLE_MAP_API_KEY; // Google key is store in envirnment variable.

const Map = {
    //Load google map API using GOOGLE_MAP_API_KEY.
    loadGoogleMapScript: (callback) => {
        if (typeof window.google === 'object' && typeof window.google.maps === 'object') {
            callback();
        } else {
            const googleMapScript = document.createElement("script");
            googleMapScript.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAP_API_KEY}&libraries=geometry`;
            window.document.body.appendChild(googleMapScript);
            googleMapScript.addEventListener("load", callback);
        }
    },
    initGoogleMap: (latitude, longitude, googleMapRef, callback) => {
        window.mydata = new window.google.maps.Map(googleMapRef.current, {
            center: { lat: latitude, lng: longitude },
            mapTypeId: window.google.maps.MapTypeId.ROADMAP,
            mapTypeControl: false,
            streetViewControl: false,
            maxZoom: 19
        });
        window.mydatamapref = googleMapRef;
        callback(googleMapRef);

        window.geocoder = new window.google.maps.Geocoder();

        return window.mydata;
    },
    //Get Current Possition.
    getCurrentPosition: (callback) => {
        if ("geolocation" in navigator) {
            navigator.geolocation.getCurrentPosition(function (position) {
                callback(position.coords.latitude, position.coords.longitude);
            }, function (error) { callback("", ""); });
        }
        else {
            callback("", "");
        }
    },
    MapRefresh: (allmarkers, result) => {
        for (var i = 0; i < allmarkers.length; i++) {
            allmarkers[i].setVisible(false);
            if (typeof allmarkers[i].circle != 'undefined') {
                allmarkers[i].circle.setVisible(false);
            }
            let merchant = result.filter(
                (col) => col.encBID === allmarkers[i].merchantid
            );
            if (merchant.length > 0) {
                allmarkers[i].setVisible(true);
                if (typeof allmarkers[i].circle != 'undefined') {
                    allmarkers[i].circle.setVisible(true);
                }
            }
        }
    },
    RemoveAllMarker: (allmarkers) => {
        for (var i = 0; i < allmarkers.length; i++) {
            allmarkers[i].setMap(null);
        }
    },
    RemoveAllmarkerCluster: (markerClustererRef) => {
        markerClustererRef.clearMarkers();
        markerClustererRef = null;
    },
    OpenMapURL: (marker) => {
        window.handleMapURL(marker.merchantid, marker.VagaroURL, marker.bidHash, marker.alias)
    },
    findNearestMarker: (location, markers, googleMap) => {
        let minDistance = Infinity;
        let nearestMarker = null;

        markers.forEach(marker => {
            const markerPosition = new window.google.maps.LatLng(marker.lat, marker.lng);
            const distance = window.google.maps.geometry.spherical.computeDistanceBetween(location, markerPosition);

            if (distance < minDistance) {
                minDistance = distance;
                nearestMarker = marker;
            }
        });

        if (nearestMarker) {
            const bounds = new window.google.maps.LatLngBounds();
            bounds.extend(location);
            bounds.extend(nearestMarker.getPosition()); // Include nearest marker in bounds            
            googleMap.fitBounds(bounds);
        }

    },
    handleSearch: async (searchQuery, googleMap, markers) => {
        if (searchQuery && googleMap) {
            window.geocoder.geocode({ address: searchQuery }, (results, status) => {
                if (status === 'OK' && results[0]) {

                    const location = results[0].geometry.location;

                    // Display the geocoded location on the map
                    googleMap.setCenter(location);

                    // Find the nearest marker
                    Map.findNearestMarker(location, markers, googleMap);

                    /*const place = results[0];
                    const viewport = place.geometry.viewport;
                    // Adjust map view
                    googleMap.fitBounds(viewport);  */
                }
            });
        }
    },
    fitBound: (googleMap, lat, lng, allmark) => {
        $('.dvmaplocation').show();
        $('.dvlistlocation').hide();
        var pos = new window.google.maps.LatLng(lat, lng);
        var bounds = new window.google.maps.LatLngBounds();
        bounds.extend(pos);
        googleMap.setCenter(pos);
        Map.findNearestMarker(pos, allmark, googleMap);
    },
    drawMarker: (googleMap, businessList, IsCurrentLocation, IsMovePosition, latituderef, longituderef, allmarkers, IsMarkerClick, setallmarkers, setHideDivId, isDrawCircle, setFilterBusinessRankData, setCurrentZoom, currentZoom, isFirstTimeInitMap, isCancel, searchQuery, setClustorMarker) => {
        var bounds = new window.google.maps.LatLngBounds();
        let isGroupMysite = false;
        const markerList = []
        businessList.map((data) => {
            if (data.isDuplicateAddress == false) {
                markerList.push({ rank: data.index, lat: data.latitude, lng: data.longitude, title: data.businessName, encBID: data.encBID, bidHash: data.bidHash, cityCount: data.cityCount, MRadius: data.mobileServiceRadius, URL: data.cdn, VagaroURL: data.vagaroURL, alias: data.alias, countbyrank: data.countbyrank })
            }
        });
        if (businessList.length > 0) {
            if (businessList[0].isGroupMysite) {
                isGroupMysite = true;
            }
        }
        var bounds = new window.google.maps.LatLngBounds();

        if (IsCurrentLocation) {
            var LatLng = new window.google.maps.LatLng(latituderef, longituderef);
            new window.google.maps.Marker({
                position: LatLng,
                map: googleMap,
                icon: {
                    path: window.google.maps.SymbolPath.CIRCLE,
                    fillColor: '#2063C6',
                    fillOpacity: 5,
                    strokeColor: '#FFFFFF',
                    strokeWeight: 5,
                    scale: 10
                },
            });
        }


        var DefaultIcon = {
            path: "M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0z", //SVG path of awesomefont marker
            fillColor: '#CC4744', //color of the marker
            fillOpacity: 1,
            strokeWeight: 0,
            scale: 0.09, //size of the marker, careful! this scale also affects anchor and labelOrigin
            anchor: new window.google.maps.Point(200, 510), //position of the icon, careful! this is affected by scale
            labelOrigin: new window.google.maps.Point(205, 190) //position of the label, careful! this is affected by scale
        }

        var HoverIcon = {
            path: "M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0z", //SVG path of awesomefont marker
            fillColor: '#B43136', //color of the marker
            fillOpacity: 1,
            strokeWeight: 0,
            scale: 0.09, //size of the marker, careful! this scale also affects anchor and labelOrigin
            anchor: new window.google.maps.Point(200, 510), //position of the icon, careful! this is affected by scale
            labelOrigin: new window.google.maps.Point(205, 190) //position of the label, careful! this is affected by scale
        }

        var ClickIcon = {
            path: "M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0z", //SVG path of awesomefont marker
            fillColor: '#942B28', //color of the marker
            fillOpacity: 1,
            strokeWeight: 0,
            scale: 0.11, //size of the marker, careful! this scale also affects anchor and labelOrigin
            anchor: new window.google.maps.Point(200, 510), //position of the icon, careful! this is affected by scale
            labelOrigin: new window.google.maps.Point(205, 190) //position of the label, careful! this is affected by scale
        }

        var allmark = [];
        const markerInstances = markerList.map((point, index) => {
            var pos = new window.google.maps.LatLng(point.lat, point.lng);
            bounds.extend(pos);
            var marker = new window.google.maps.Marker({
                position: pos,
                map: googleMap,
                icon: DefaultIcon,
                label: {
                    text: point.countbyrank.toString(), //text inside marker
                    color: '#FFFFFF', //color of the text inside marker
                },
                originalLabel: point.countbyrank.toString(),
                merchantid: point.encBID,
                bidHash: point.bidHash,
                URL: point.URL,
                VagaroURL: point.VagaroURL,
                lat: point.lat,
                lng: point.lng,
                rank: point.rank,
                alias: point.alias,
                isClickable: false,
                index: index
            });

            if (point.cityCount > 0 && isDrawCircle) {
                marker.circle = new window.google.maps.Circle({
                    strokeColor: "#2A90D6",
                    strokeOpacity: 1,
                    strokeWeight: 1,
                    fillColor: "#2A90D6",
                    fillOpacity: 0.20,
                    map: googleMap,
                    center: pos,
                    radius: (point.MRadius * 1.60934) * 1000
                });
                marker.circle.bindTo('center', marker, 'position');
            }
            allmark.push(marker);
            window.google.maps.event.addListener(marker, 'click', function () {

                setTimeout(() => {
                    var x = document.getElementsByClassName('gm-ui-hover-effect');
                    if (x && x[0]) {
                        x[0].remove()
                    }
                }, 10);

                if (isGroupMysite) {
                    setFilterBusinessRankData(point.rank);
                }
                else {
                    Map.mapClickCallback(point.rank);
                }

            });

            window.google.maps.event.addListener(
                marker,
                "mouseover",
                (function (marker) {
                    return function () {
                        if (marker.isClickable == false) {
                            marker.setIcon(HoverIcon);
                        }
                    };
                })(marker)
            );

            window.google.maps.event.addListener(
                marker,
                "click",
                (function (marker) {
                    return function () {

                        $.map(allmark, function (e) {
                            e.isClickable = false;
                            e.setIcon(DefaultIcon);
                        });

                        marker.setIcon(ClickIcon);
                        marker.isClickable = true;
                    };
                })(marker)
            );

            window.google.maps.event.addListener(
                marker,
                "mouseout",
                (function (marker, i) {
                    return function () {
                        if (marker.isClickable == false) {
                            marker.setIcon(DefaultIcon);
                        }
                    };
                })(marker)
            );
            return marker;
        });

        window.google.maps.event.addListener(
            googleMap,
            "click",
            (function (event) {
                return function () {
                    var $allmapboxdiv = $('.active-cardbox');

                    $.map($allmapboxdiv, function (e) {
                        $(e).removeClass('active-cardbox');
                    });

                    $.map(allmark, function (e) {
                        e.isClickable = false;
                        e.setIcon(DefaultIcon);
                    });

                    if (isGroupMysite) {
                        setFilterBusinessRankData(0);
                    }
                };
            })(googleMap)
        );

        window.google.maps.event.addListenerOnce(googleMap, 'tilesloaded', function () {
            if (isFirstTimeInitMap) {
                setCurrentZoom(googleMap.getZoom());
            }
        });

        window.google.maps.event.addListener(
            googleMap,
            "idle",
            (function (event) {
                return function () {

                    let bounds = event.getBounds();
                    var ne = bounds.getNorthEast();
                    var sw = bounds.getSouthWest();
                    bounds = new window.google.maps.LatLngBounds(sw, ne);
                    var IsRecordFound = false;
                    let hideDivIds = [];



                    if (isGroupMysite) {
                        $(".map-div").hide();
                        hideDivIds = $.map(allmark, function (e) {
                            return e.rank;
                        });
                        var filteredMarkers = allmark.filter(function (marker) {
                            return bounds.contains(marker.getPosition());
                        });

                        $.map(filteredMarkers, function (data) {
                            $(".div-" + data.rank).show();
                            IsRecordFound = true;
                            hideDivIds = hideDivIds.filter(
                                (col) => col != data.rank.toString()
                            );
                        });

                        setHideDivId(hideDivIds);
                        if (IsRecordFound == false) {
                            const isMobile = window.matchMedia("(max-width: 767px)");
                            if (isMobile.matches == false) {
                                $("#dvnorecord").show();
                            }
                        }
                        else {
                            $("#dvnorecord").hide();
                        }
                    }
                    else {
                        var sortedMarker = []
                        var filterMark = []
                        sortedMarker = allmark.sort(function (a, b) {
                            return a.rank > b.rank ? 1 : -1;
                        });
                        for (var i = 0; i < sortedMarker.length; i++) {
                            var localmarker = sortedMarker[i];
                            $(".div-" + localmarker.rank).hide();
                            if (bounds.contains(new window.google.maps.LatLng(localmarker.lat, localmarker.lng))) {
                                filterMark.push(localmarker);
                                $(".div-" + localmarker.rank).show();
                                IsRecordFound = true;
                            }
                            else {
                                hideDivIds.push(localmarker.rank);
                            }
                        }
                        setHideDivId(hideDivIds);
                        if (IsRecordFound == false) {
                            const isMobile = window.matchMedia("(max-width: 767px)");
                            if (isMobile.matches == false) {
                                $("#dvnorecord").show();
                            }
                        }
                        else {
                            $("#dvnorecord").hide();
                        }
                        if (filterMark.length > 0) {
                            for (var i = 0; i < filterMark.length; i++) {
                                let fmarker = allmark.filter(
                                    (col) => col.originalLabel === filterMark[i].rank.toString()
                                );
                                allmark[fmarker[0].index].setLabel({
                                    text: (i + 1).toString(),
                                    color: '#FFFFFF'
                                });
                                $("#span_" + (fmarker[0].index + 1)).text((i + 1).toString());
                            }
                        }
                    }
                };
            })(googleMap)
        );

        window.google.maps.event.addListener(
            googleMap,
            "dragend",
            (function (event) {
                return function () {
                    let bounds = event.getBounds();
                    var ne = bounds.getNorthEast();
                    var sw = bounds.getSouthWest();
                    bounds = new window.google.maps.LatLngBounds(sw, ne);
                    var IsRecordFound = false;
                    let hideDivIds = [];

                    if (isGroupMysite) {
                        $(".map-div").hide();
                        hideDivIds = $.map(allmark, function (e) {
                            return e.rank;
                        });
                        var filteredMarkers = allmark.filter(function (marker) {
                            return bounds.contains(marker.getPosition());
                        });
                        $.map(filteredMarkers, function (data) {
                            $(".div-" + data.rank).show();
                            IsRecordFound = true;
                            hideDivIds = hideDivIds.filter(
                                (col) => col != data.rank.toString()
                            );
                        });
                        setHideDivId(hideDivIds);
                        if (IsRecordFound == false) {
                            const isMobile = window.matchMedia("(max-width: 767px)");
                            if (isMobile.matches == false) {
                                $("#dvnorecord").show();
                            }
                        }
                        else {
                            $("#dvnorecord").hide();
                        }
                    }
                    else {
                        var sortedMarker = []
                        var filterMark = []
                        sortedMarker = allmark.sort(function (a, b) {
                            return a.rank > b.rank ? 1 : -1;
                        });
                        for (var i = 0; i < sortedMarker.length; i++) {
                            var localmarker = sortedMarker[i];
                            $(".div-" + localmarker.rank).hide();
                            if (bounds.contains(new window.google.maps.LatLng(localmarker.lat, localmarker.lng))) {
                                filterMark.push(localmarker);
                                $(".div-" + localmarker.rank).show();
                                IsRecordFound = true;
                            }
                            else {
                                hideDivIds.push(localmarker.rank);
                            }
                        }
                        setHideDivId(hideDivIds);
                        if (IsRecordFound == false) {
                            const isMobile = window.matchMedia("(max-width: 767px)");
                            if (isMobile.matches == false) {
                                $("#dvnorecord").show();
                            }
                        }
                        else {
                            $("#dvnorecord").hide();
                        }
                        if (filterMark.length > 0) {
                            for (var i = 0; i < filterMark.length; i++) {
                                let fmarker = allmark.filter(
                                    (col) => col.originalLabel === filterMark[i].rank.toString()
                                );
                                allmark[fmarker[0].index].setLabel({
                                    text: (i + 1).toString(),
                                    color: '#FFFFFF'
                                });
                                $("#span_" + (fmarker[0].index + 1)).text((i + 1).toString());
                            }
                        }
                    }

                };
            })(googleMap)
        );

        window.google.maps.event.addListener(
            googleMap,
            "zoom_changed",
            (function (event) {
                return function () {
                    let bounds = event.getBounds();
                    var ne = bounds.getNorthEast();
                    var sw = bounds.getSouthWest();
                    bounds = new window.google.maps.LatLngBounds(sw, ne);
                    var IsRecordFound = false;
                    let hideDivIds = [];

                    if (isGroupMysite) {
                        $(".map-div").hide();
                        hideDivIds = $.map(allmark, function (e) {
                            return e.rank;
                        });
                        var filteredMarkers = allmark.filter(function (marker) {
                            return bounds.contains(marker.getPosition());
                        });
                        $.map(filteredMarkers, function (data) {
                            $(".div-" + data.rank).show();
                            IsRecordFound = true;
                            hideDivIds = hideDivIds.filter(
                                (col) => col != data.rank.toString()
                            );
                        });
                        setHideDivId(hideDivIds);
                        if (IsRecordFound == false) {
                            const isMobile = window.matchMedia("(max-width: 767px)");
                            if (isMobile.matches == false) {
                                $("#dvnorecord").show();
                            }
                        }
                        else {
                            $("#dvnorecord").hide();
                        }
                    }
                    else {
                        var sortedMarker = []
                        var filterMark = []
                        sortedMarker = allmark.sort(function (a, b) {
                            return a.rank > b.rank ? 1 : -1;
                        });
                        for (var i = 0; i < sortedMarker.length; i++) {
                            var localmarker = sortedMarker[i];
                            $(".div-" + localmarker.rank).hide();
                            if (bounds.contains(new window.google.maps.LatLng(localmarker.lat, localmarker.lng))) {
                                filterMark.push(localmarker);
                                $(".div-" + localmarker.rank).show();
                                IsRecordFound = true;
                            }
                            else {
                                hideDivIds.push(localmarker.rank);
                            }
                        }
                        setHideDivId(hideDivIds);
                        if (IsRecordFound == false) {
                            const isMobile = window.matchMedia("(max-width: 767px)");
                            if (isMobile.matches == false) {
                                $("#dvnorecord").show();
                            }
                        }
                        else {
                            $("#dvnorecord").hide();
                        }
                        if (filterMark.length > 0) {
                            for (var i = 0; i < filterMark.length; i++) {
                                let fmarker = allmark.filter(
                                    (col) => col.originalLabel === filterMark[i].rank.toString()
                                );
                                allmark[fmarker[0].index].setLabel({
                                    text: (i + 1).toString(),
                                    color: '#FFFFFF'
                                });
                                $("#span_" + (fmarker[0].index + 1)).text((i + 1).toString());
                            }
                        }
                    }

                };
            })(googleMap)
        );


        if (isCancel) {
            let myLatLng = new window.google.maps.LatLng(latituderef, longituderef)
            googleMap.panTo(myLatLng);

            var newCenter = new window.google.maps.LatLng(latituderef, longituderef);
            googleMap.setCenter(newCenter);

            if (currentZoom > 0) {
                googleMap.setZoom(currentZoom)
            }

            if (googleMap) {
                googleMap.setCenter(newCenter);
                Map.findNearestMarker(newCenter, allmark, googleMap);
            }
        }
        else {
            if (IsMovePosition) {

                if (utils.Validate(searchQuery)) {
                    Map.handleSearch(searchQuery, googleMap, allmark)
                }

                let myLatLng = new window.google.maps.LatLng(latituderef, longituderef)
                googleMap.panTo(myLatLng);

                var newCenter = new window.google.maps.LatLng(latituderef, longituderef);
                googleMap.setCenter(newCenter);

            }
        }
        if (isCancel == false) {
            googleMap.fitBounds(bounds); // the map to contain all markers
        }

        if (isGroupMysite) {
            var markerCluster = new MarkerClusterer({ markers: markerInstances, map: googleMap, renderer: new MyCustomRenderer(), algorithm: new GridAlgorithm({}) });
            setClustorMarker(markerCluster);
            window.google.maps.event.addListener(
                markerCluster,
                "click",
                (function (event) {
                    return function () {
                        var $allmapboxdiv = $('.active-cardbox');

                        $.map($allmapboxdiv, function (e) {
                            $(e).removeClass('active-cardbox');
                        });

                        $.map(allmark, function (e) {
                            e.isClickable = false;
                            e.setIcon(DefaultIcon);
                        });

                        if (isGroupMysite) {
                            setFilterBusinessRankData(0);
                        }

                    };
                })(googleMap)
            );

        }
        setallmarkers(allmark);
    },
    mapClickCallback: (rank) => {
        var $container = $('#divlocation'),
            $scrollTo = $('.div-' + rank);

        var $allmapboxdiv = $('.map-box');
        for (var i = 0; i < $allmapboxdiv.length; i++) {
            $($allmapboxdiv[i]).removeClass('active-cardbox');
        }
        // Help to designer for remove media check
        const isMobile = window.matchMedia("(max-width: 767px)");
        if (isMobile.matches) {
            $container.scrollLeft(
                $scrollTo.offset().left - $container.offset().left + $container.scrollLeft()
            );
            // Or you can animate the scrolling:
            $container.animate({
                scrollLeft: $scrollTo.offset().left - $container.offset().left + $container.scrollLeft()
            });
        }
        else {
            $container.scrollTop(
                $scrollTo.offset().top - $container.offset().top + $container.scrollTop()
            );
            // Or you can animate the scrolling:
            $container.animate({
                scrollTop: $scrollTo.offset().top - $container.offset().top + $container.scrollTop()
            });
        }
        $scrollTo.addClass("active-cardbox");
    }

}
export { Map }



class MyCustomRenderer {
    constructor() {
        // Initialize any properties or settings for your custom renderer
    }
    render({ count, position }, stats) {

        const color = "rgba(184,53,57,1)";//this.palette(count / stats.clusters.markers.max);
        const svg = window.btoa(`<svg fill="${color}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240"><circle cx="120" cy="120"  r="70" /> </svg>`);

        // create marker using svg icon
        return new window.google.maps.Marker({
            position,
            icon: {
                url: `data:image/svg+xml;base64,${svg}`,
                scaledSize: new window.google.maps.Size(75, 75),
            },
            label: {
                text: String(count),
                color: "rgba(255,255,255,1)",
                fontSize: "12px",
            },
            // adjust zIndex to be above other markers
            zIndex: Number(window.google.maps.Marker.MAX_ZINDEX) + count,
        });
    }


    //include onAdd & onRemove to avoid undefined exceptions
    onAdd() {

    }


    onRemove() {

    }
}